interface Props {
  children: React.ReactNode;
}

const LoginCard = ({ children }: Props) => {
  return <div className="w-full max-w-md bg-white rounded-[28px] shadow-lg px-10 py-12">{children}</div>;
};

export default LoginCard;
